<template>
  <WalletTakt
    :selected="$route.matched[3] &&
              ['ProjectWalletWorkPackageInfo',
              'ProjectWalletWorkCards',
              'ProjectWalletQualityCards',
              'ProjectWalletDefectCards',
              'ProjectWalletHandoverCards',
              'ProjectWalletLogisticCards',
              'ProjectWalletDesignCards'
              ].includes($route.matched[3].name) &&
              wallet_column === selected_column?true:false"
    @click.native="setMobileWalletShowSettings(false)"
    :takt_index="takt_index"
  >
    <template #dialog v-if="$route.matched[3] && $route.matched[3].name === 'ProjectWalletTrainDetails' && wallet_column === selected_column">
      <router-view />
    </template>
    <template #header>
      <WalletTaktHeader
        :takt_time="takt_index >= -1 &&
                    takt_index <= getCalendar(project_id).takt_times.length?
                    getCalendar(project_id).takt_times[takt_index]:false"
        :show_calendar_weeks="isShowCalendarWeeks"
        @click.native="setShowCalendarWeeks"
        >
        <template #settings-button>
          <TIcon
            v-if="$vuetify.breakpoint.smAndDown && !$route.matched[3] ||
              $vuetify.breakpoint.smAndDown && $route.matched[3] &&
              $route.matched[3].name !== 'ProjectWalletWorkPackageInfo'"
            name="gear"
            @click.native.prevent.stop="setMobileWalletShowSettings(true)"
          />
        </template>
      </WalletTaktHeader>
    </template>
    <template #body>
      <WalletTaktBody>
        <WalletTrain
          v-for="(section, section_index) in getSectionArray()"
          :key="`section${section_index}`"
          :shadow="section_index === 0?false:true"
          :no_margin_top="section_index === 0?true:false"
          :wallet_settings="getWalletSettings"
          :step_cards="getStepCards({
            project_id: project_id,
            takt_index: takt_index,
            section: section,
            })"
          >
          <template #name="{wallet_settings}">
            <div
              v-if="wallet_settings.sorting === 'taktareas'"
              :style="`display: flex; align-items: center; cursor: pointer; ${microlevel_taktarea_filter.includes($store.state.Ultra.taktareas[section].id)?'outline: 1px solid white':''}`"
              @click="setValue({key: 'microlevel_taktarea_filter', value: microlevel_taktarea_filter.includes($store.state.Ultra.taktareas[section].id)?[]:[$store.state.Ultra.taktareas[section].id]})"
            >
              <TText medium :text="$store.state.Ultra.taktareas[section].name" />
              <TIcon name="chevron-right" />
            </div>
            <!-- <div >{{ section + wallet_settings }}}</div> -->
            <div
              v-else-if="wallet_settings.sorting === 'trains' || !wallet_settings.sorting"
              @click.stop="$router.push({name: 'ProjectWalletTrainDetails', params: {train_id: getTrain(section).id, selected_column: wallet_column}})"
              style="display: flex; align-items: center; cursor: pointer;"
            >
              <TText medium :text="getTrain(section).name" />
              <TIcon name="chevron-right" />
            </div>
            <div
              v-else-if="wallet_settings.sorting === 'colors'"
              :class="`color-badge ${section.value} t-shadow`"
              />
            <TIcon
              v-else-if="wallet_settings.sorting === 'status'"
              :name="section.icon"
            />
            <TIcon
              v-else-if="wallet_settings.sorting === 'icons'"
              :name="getNewIcon(section.icon)"
              color="primary"
              large
            />
          </template>
          <template #content="{wallet_settings, step_cards}">
            <template v-if="isWalletShowWorkpackages">
              <!-- :class="`${workpackage.color}`" -->
              <WalletWorkPackageRework
                v-for="(workpackage, index) in getWorkpackagesInTaktComputed(takt_index, wallet_settings.sorting, section)"
                :class="
                (isShowOwnWps &&
                getOwnTWorkPackages(project_id).length !== 0 &&
                !getOwnTWorkPackages(project_id).includes(workpackage.id))
                ?
                'grey darken-2':`${workpackage.color}`
                "
                :key="workpackage.id"
                :selected="tworkpackage_id === workpackage.id?'-selected':''"
                :index="index"
                :count="getWorkpackagesInTaktComputed(takt_index, wallet_settings.sorting, section).length + step_cards.count"
                :is_show_status_popup="open_status_wp_id === workpackage.id"
                >
                <!-- :other_selected="$route.matched[3] && $route.matched[3].name === 'ProjectWalletWorkPackageInfo' &&
                wallet_column === selected_column &&
                tworkpackage_id !== workpackage.id?'-other-selected':''" -->
                <template #header>
                  <WorkPackageHead
                    :head="{
                      token: workpackage.token,
                      name: workpackage.name,
                      icon: workpackage.icon,
                      area: workpackage.taktarea.name,
                      status_done_count: $store.state.Ultra.status_array.findIndex(status => status.name === workpackage.status),
                      status_is_stop: workpackage.stop_status,
                    }"
                    location="ProjectWallet"
                    :foreground_color="calc_fg_hex(workpackage.textcolor)"
                    @selectStatus="
                    updateUObject({
                      url: [
                        {projects: project_id},
                        {trains: workpackage.train.id},
                        {taktareas: workpackage.taktarea.id},
                        {twaggons: workpackage.twaggon.id},
                        {tworkpackages: workpackage.id},
                      ],
                      url_suffix: $event.tooltip.toLowerCase() !== 'stop'? '/status':'/stopstatus',
                      update: $event.tooltip.toLowerCase() !== 'stop'?
                      {status: workpackage.status !== $event.tooltip.toLowerCase()?$event.tooltip.toLowerCase():'none'}
                      :
                      {stop_status: workpackage.stop_status !== 'none'?'none':'stop'}
                    })
                    "
                    @selectStopStatus="
                    updateUObject({
                      url: [
                        {projects: project_id},
                        {trains: workpackage.train.id},
                        {taktareas: workpackage.taktarea.id},
                        {twaggons: workpackage.twaggon.id},
                        {tworkpackages: workpackage.id},
                      ],
                      url_suffix: '/stopstatus',
                      update: {stop_status: workpackage.stop_status !== 'none'?'none':'stop'}
                    }).then(() => {
                        $event !== ''?
                        createLogListComment({
                          project_id: project_id,
                          train_id: workpackage.train.id,
                          taktarea_id: workpackage.taktarea.id,
                          twaggon_id: workpackage.twaggon.id,
                          workpackage_id: workpackage.id,
                          data: {
                            comment: $event,
                          },
                        }):''
                      })
                    "
                    @openCommentInput="workpackage.id !== tworkpackage_id?walletWorkpackageClick(workpackage):''"
                    @clickHeader="walletWorkpackageClick(workpackage)"
                    @toggle_status_popup="$event?(open_status_wp_id = workpackage.id):(open_status_wp_id === workpackage.id?open_status_wp_id = -1:'')"
                  />
                </template>
                <template #body>
                  <router-view
                    v-if="$route.matched[3] && $route.matched[3].name === 'ProjectWalletWorkPackageInfo' &&
                    tworkpackage_id === workpackage.id"
                    :key="tworkpackage_id+$route.matched[3].name"
                    />
                </template>
              </WalletWorkPackageRework>
            </template>
            <!-- step cards new -->
            <template v-if="true">
              <template v-for="(step_type) in ['work', 'quality', 'defect', 'handover', 'logistic', 'design']">
              <WalletWorkPackageRework
                v-for="(step_card) in step_cards[`${step_type}_cards`]"
                class="white"
                :key="`${step_type}card${step_card.id}`"
                :selected="$props[`${step_type}_card_id`] === step_card.id?'-selected':''"
                :index="getWorkpackagesInTaktComputed(takt_index, wallet_settings.sorting, section).length + step_card.global_index"
                :count="getWorkpackagesInTaktComputed(takt_index, wallet_settings.sorting, section).length + step_cards.count"
                >
                <!-- :count="getWorkpackagesInTaktComputed(takt_index, wallet_settings.sorting, section).length" -->
                <!-- :other_selected="$route.matched[3] && $route.matched[3].name === 'ProjectWalletWorkPackageInfo' &&
                wallet_column === selected_column &&
                tworkpackage_id !== workpackage.id?'-other-selected':''" -->
                <template #header>
                  <WorkPackageHead
                    :key="`${step_card.id}stepcard${$store.state.ProjectWallet.update_key_stepcard}`"
                    :head="{
                      token: step_card.work_package_token,
                      name: step_card.work_package_name,
                      icon: step_card.work_package_icon,
                      area: step_card.taktarea_name,
                      step_card_done: step_card.done,
                      status_done_count: step_card.done?5:0,
                    }"
                    location="ProjectWallet"
                    foreground_color="#000"
                    :is_step_card_header="true"
                    :step_card="step_card"
                    :step_type="step_type"
                    @clickHeader="
                    new_substep_search_step_id?
                    (
                      setValue({key: 'new_substep_step_id', value: step_card.id}),
                      setValue({key: 'new_substep_step_type', value: step_type})
                    )
                    :
                    ($props[`${step_type}_card_id`] === step_card.id
                      ? $router.push({
                          name: 'ProjectWalletTakt'
                        })
                      : $router.push({
                          name: `ProjectWallet${step_type.substring(0,1).toUpperCase()}${step_type.substring(1)}Cards`,
                          params: {
                            project_id: project_id,
                            train_id: step_card.train_id,
                            taktarea_id: step_card.taktarea_id,
                            twaggon_id: step_card.twaggon_id,
                            tworkpackage_id: step_card.work_package_id,
                            takt_index: $route.params.takt_index,
                            [`${step_type}_card_id`]: step_card.id,
                            selected_column: wallet_column,
                          }
                      })
                      )
                      "
                      @toggleStepCardStatus="
                      updateUObject({
                        url: [
                          {projects: project_id},
                          {trains: step_card.train_id},
                          {taktareas: step_card.taktarea_id},
                          {twaggons: step_card.twaggon_id},
                          {tworkpackages: step_card.work_package_id},
                          {[`t${step_type}steps`]: step_card.id},
                        ],
                        update: {
                          [step_type === 'Material'?'status':'done']: !step_card.done
                        }
                        }),
                        updateStepCardStatus({
                          project_id: project_id,
                          step_id: step_card.id,
                          step_type: step_type,
                          done: !step_card.done,
                          offset: false,
                          wallet_column: wallet_column,
                          }).then(() => {
                            increaseUpdateKeyStepCard();
                            })

                          "
                  />
                </template>
                <template #body>
                  <router-view
                    v-if="$route.matched[3] && $route.matched[3].name === `ProjectWallet${step_type.substring(0,1).toUpperCase()}${step_type.substring(1)}Cards` &&
                          $props[`${step_type}_card_id`] === step_card.id"
                    />
                </template>
              </WalletWorkPackageRework>
            </template>
            </template>
            
          </template>
        </WalletTrain>
        <WalletTrain
          :shadow="true"
          :no_margin_top="false"
          />
      </WalletTaktBody>
    </template>
  </WalletTakt>
</template>
<script>
  import colors from 'vuetify/lib/util/colors';
  import {  mapActions, mapGetters, mapState } from 'vuex';

  import { WalletMixin } from '@/mixins/Wallet.mixin.js'
  import WorkPackageHead from '@/modules/WorkPackageWIP/WorkPackageHead.module.vue';

  export default {
    props: [
      'project_id',
      'takt_index',
      'tworkpackage_id',
      'workstep_card_id',
      'work_card_id',
      'quality_card_id',
      'defect_card_id',
      'handover_card_id',
      'logistic_card_id',
      'design_card_id',
      'wallet_column',
      'selected_column'
    ],
    components: {
      WorkPackageHead,
    },
    mixins: [
      WalletMixin
    ],
    data: () => ({
      open_status_wp_id: -1,
    }),
    computed: {
      ...mapGetters('View', [
          'isShowOwnWps',
      ]),
      ...mapGetters('Project', [
        'getOwnTWorkPackages',
      ]),
      ...mapState('View', [
        'isMicroView'
      ])
    },
    methods: {
      ...mapActions('WorkPackageLogList', [
        'createLogListComment',
      ]),
      calc_fg_hex(color) {
        let textcolor = color;
        if (textcolor.includes('black')) {
          return '#000'
        } else if (textcolor.includes('white')) {
          return '#FFF'
        } else {
          return colors[textcolor];
        }
      },
    }
  }
</script>
<style>
</style>
